import React, { useState, useEffect } from 'react';
import './ClientDetails.css';

function ClientDetails({ onBack }) {
  const [user, setUser] = useState(null);
  const [showClientModal, setShowClientModal] = useState(false);

  // Define sampleClients so the modal can map over it
  const sampleClients = [
    { id: 1, name: 'Shruti Raj', portfolio: '₹12L', phone: '+91 99887 76655', email: 'shurutiraj14@gmail.com' }
  ];

  // Partner detection + local color/toggle state (persisted via localStorage)
  const [isPartner, setIsPartner] = useState(false);
  const [partnerColorEnabledLocal, setPartnerColorEnabledLocal] = useState(
    localStorage.getItem('partnerColorEnabled') === 'true'
  );
  const [logoColorLocal, setLogoColorLocal] = useState(
    localStorage.getItem('logoColor') || '#007bff'
  );

  useEffect(() => {
    // Get user data from localStorage
    const userData = localStorage.getItem('user');
    const loginType = localStorage.getItem('loginType');
    if (userData) {
      const parsed = JSON.parse(userData);
      setUser(parsed);
      setIsPartner(parsed?.role === 'partner' && loginType === 'Partner');
    }
  }, []);

  const handleTotalClientsClick = () => {
    setShowClientModal(true);
  };

  const handleCloseModal = () => {
    setShowClientModal(false);
  };

  return (
    <div className="client-details-container">
      <nav className="client-nav">
        <h2>Client Details Dashboard</h2>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
          {isPartner && (
            <>
              <label htmlFor="enableLogoColorDash" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <input
                  id="enableLogoColorDash"
                  type="checkbox"
                  checked={partnerColorEnabledLocal}
                  onChange={(e) => {
                    const enabled = e.target.checked;
                    setPartnerColorEnabledLocal(enabled);
                    localStorage.setItem('partnerColorEnabled', String(enabled));
                  }}
                />
                Enable Logo Color
              </label>
              <input
                type="color"
                value={logoColorLocal}
                onChange={(e) => {
                  const color = e.target.value;
                  setLogoColorLocal(color);
                  localStorage.setItem('logoColor', color);
                }}
                aria-label="Pick logo color"
                disabled={!partnerColorEnabledLocal}
              />
            </>
          )}
          <button className="back-btn" onClick={onBack}>Back to Home</button>
        </div>
      </nav>
      
      <div className="client-content">
        <div className="welcome-section">
          <h3>Welcome, {user?.username || 'Partner'}!</h3>
          <p>Manage your client portfolio and details here.</p>
        </div>
        
        <div className="client-stats">
          <div className="stat-card clickable" onClick={handleTotalClientsClick}>
            <h4>Total Clients</h4>
            <p className="stat-number">1</p>
            <small>Click to view all</small>
          </div>
          <div className="stat-card">
            <h4>Active Portfolios</h4>
            <p className="stat-number">1</p>
          </div>
          <div className="stat-card">
            <h4>Total AUM</h4>
            <p className="stat-number">₹12L</p>
          </div>
        </div>
        
        <div className="client-list">
          <h4>Recent Clients</h4>
          <div className="client-item">
            <span>Shruti Raj - Portfolio Value: ₹12L</span>
          </div>
        </div>
      </div>

      {/* Client List Modal */}
      {showClientModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="client-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>All Clients (1)</h3>
              <button className="close-modal" onClick={handleCloseModal}>×</button>
            </div>
            <div className="modal-content">
              <div className="client-grid">
                {sampleClients.map(client => (
                  <div key={client.id} className="client-card">
                    <div className="client-info">
                      <h4>{client.name}</h4>
                      <p className="portfolio-value">{client.portfolio}</p>
                      <p className="client-contact">{client.phone}</p>
                      <p className="client-email">{client.email}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ClientDetails;